
import { email, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { getErrorMessage } from "@/helpers/validation";
import { ModuleNames } from "@/store";
import { AuthActions } from "@/store/auth";
import ClarityInput from "@/components/clarity/ClarityInput.vue";
import ClarityButton from "@/components/clarity/ClarityButton.vue";

export default Vue.extend({
  name: "LoginView",
  components: {
    ClarityButton,
    ClarityInput,
  },
  // middleware: ["is-guest"],
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  data: (): {
    email: string;
    password: string;
    formError: string;
    isLoading: boolean;
  } => ({
    email: "",
    password: "",
    formError: "",
    isLoading: false,
  }),
  computed: {
    ...mapGetters(ModuleNames.auth, { isAuthenticated: "isAuthenticated" }),
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(): void {
        if (this.isAuthenticated) {
          this.$router.push({ name: "account" });
        }
      },
    },
  },

  methods: {
    ...mapActions(ModuleNames.auth, [AuthActions.LOGIN]),
    getErrorMessage(validation: any): string {
      return getErrorMessage(validation);
    },
    async loginUser(): Promise<void> {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$noty.error(this.$t("formContainsErrors") as string);
        return;
      }
      this.isLoading = true;
      try {
        await this.login({ email: this.email, password: this.password });
        if (this.$route.query.return) {
          await this.$router.push({ name: this.$route.query.return as string });
        }
      } catch (e: any) {
        this.$noty.error(this.$t("formContainsErrors") as string);
        this.formError = this.$t(e.message) as string;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
